export default {
  defaultOption: {
    shading: null,
    realisticMaterial: {
      textureTiling: 1,
      textureOffset: 0,
      detailTexture: null
    },
    lambertMaterial: {
      textureTiling: 1,
      textureOffset: 0,
      detailTexture: null
    },
    colorMaterial: {
      textureTiling: 1,
      textureOffset: 0,
      detailTexture: null
    },
    hatchingMaterial: {
      textureTiling: 1,
      textureOffset: 0,
      paperColor: '#fff'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/echarts-gl@2.0.9/node_modules/echarts-gl/lib/component/common/componentShadingMixin.js
// module id = null
// module chunks = 